import { useEffect, useState } from "react";
import { config } from "./config";
import { reportVacancy } from "./services";

function VacancySuggestion({
  property_id,
  address,
  callback,
}: {
  property_id: string | undefined;
  address: string | undefined;
  callback: (done: boolean) => void;
}) {
  const [unit, setUnit] = useState("");

  useEffect(() => {
    window.onpopstate = () => {
      if (callback) callback(false);
    };
  });

  function report() {
    const reportObj = {
      propertyId: property_id,
      address,
      unit,
      sourceSystem: config.CITY,
    };
    reportVacancy(reportObj);
    callback(true);
  }

  return (
    <div className="report-screen">
      <div>
        <button className="close-btn" onClick={() => callback(false)}>
          ×
        </button>

        <h3>Would you like to report a vacant unit?</h3>
        <label>Address</label>
        <input type="text" disabled value={address} />
        <label>Unit</label>
        <input
          type="text"
          value={unit!}
          onChange={(event) => setUnit(event.target.value)}
        />
        <div className="submit-button-wrapper">
          <button className="report-vacancy" onClick={() => report()}>
            Report a Vacant Unit
          </button>
        </div>
      </div>
    </div>
  );
}

export default VacancySuggestion;
